import React from 'react'
import { useTranslation } from 'react-i18next'
import UseCaseListWrapper from './UseCaseListWrapper'

const UseCasesRelated = ({ category }) => {
  const { t } = useTranslation()

  return category ? (
    <UseCaseListWrapper filterBy={category}>
      <h1>{t('useCases.relatedSection.title', { category: t(`categories.${category}.title`).toLowerCase() })}</h1>
    </UseCaseListWrapper>
  ) : null
}

export default UseCasesRelated
